//  custom function inside the iframe code
export function openLink(url, type, host) {
  const isExternalLink = type === "external";
  const isAndroid = /Android/.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);

  if (isAndroid) {
    if (
      url.startsWith("https://data-assets.wort.lu/elections/faq/index.html") ||
      url.startsWith(
        "https://www.wort.lu/de/lokales/die-wichtigsten-fragen-zu-den-gemeindewahlen-am-11-juni-63bd7111de135b923672b9fc"
      )
    ) {
      window.open(url, "_blank");
    } else {
      window.parent.postMessage({ type: "navigate", url: url }, host);
    }
  } else if (isIOS) {
    if (
      url.startsWith("https://data-assets.wort.lu/elections/faq/index.html") ||
      url.startsWith(
        "https://www.wort.lu/de/lokales/die-wichtigsten-fragen-zu-den-gemeindewahlen-am-11-juni-63bd7111de135b923672b9fc"
      )
    ) {
      window.parent.postMessage({ type: "navigate", url: url }, host);
    } else {
      window.open(url, "_blank");
    }
  } else {
    // Default behavior for other platforms
    isExternalLink
      ? window.open(url, "_blank")
      : window.parent.postMessage({ type: "navigate", url: url }, host);
  }
}

// extract all commune entites
export function extractCommuneEntites(json) {
  const communeEntites = [];

  function searchEntites(entites) {
    for (const entite of entites) {
      if (entite.type === "COMMUNE") {
        communeEntites.push(entite);
      }

      if (entite.entites) {
        searchEntites(entite.entites);
      }
    }
  }

  searchEntites(json.entite);

  return communeEntites;
}

// get winning party by commune
export function getWinningPartyByEntite(communeEntites) {
  const winningParties = communeEntites.map((entite) => {
    let leadingListe = null;
    if (entite.resultats.listes) {
      for (const liste of entite.resultats.listes) {
        if (
          !leadingListe ||
          Number(liste.pourcentage) > Number(leadingListe.pourcentage)
        ) {
          leadingListe = liste;
        }
      }
    } else {
      //console.log(entite);
      // small commune - no listes - majoritaire
    }
    return {
      id: entite.id,
      entite: entite.nom,
      parti: leadingListe ? leadingListe.noms[0].nom.contenu : "N/A",
      sigle: leadingListe ? leadingListe.sigles[0].sigle.contenu : "N/A",
      pourcentage: leadingListe ? leadingListe.pourcentage : "N/A",
    };
  });
  return winningParties;
}

// get all communes
export function getCommunes(communeEntites) {
  const communes = communeEntites.map((entite) => {
    return {
      id: entite.id,
      commune: entite.nom,
    };
  });
  return communes;
}

// get all parties
export function getAllParties(communeEntites) {
  const partiesMap = new Map();

  communeEntites.forEach((entite) => {
    if (entite.resultats.listes) {
      entite.resultats.listes.forEach((liste) => {
        liste.noms.forEach((nom) => {
          const partyName = nom.nom["contenu"];
          const partySigle = liste.sigles[0].sigle["contenu"];
          partiesMap.set(partyName, partySigle);
        });
      });
    }
  });

  const uniqueParties = Array.from(
    new Set(partiesMap.entries()),
    ([partyName, partySigle]) => ({ partyName, partySigle })
  );

  return uniqueParties;
}

// sort candidates by votes
export function sortCandidatesByVotes(listes) {
  const candidates = [];
  listes.forEach((liste) => {
    liste.candidats.forEach((candidate) => {
      candidates.push({ ...candidate, party: liste.sigles[0].sigle.contenu });
    });
  });
  return candidates.sort((a, b) => b.suffrages - a.suffrages);
}

// sort candidates by suffrages small commune
export function sortSmallCommunesCandidatesByVotes(people) {
  const candidates = [];
  people.forEach((candidate) => {
    if (candidate.elu === "ELU") {
      candidates.push({ ...candidate });
    }
  });

  return candidates.sort((a, b) => b.suffrages - a.suffrages);
}

export function getQueryParameter(paramName) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}

export function formatNumber(num, language) {
  const seperator = language === "en" ? "," : ".";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, seperator);
}

export function formatGermanNumber(n) {
  return n.toLocaleString("de-DE");
}

export function handleImageError(event, language) {
  const placeholderImageUrl = `https://data-assets.wort.lu/elections/data/parties/${
    language === "de" ? "kandidate" : "candidate"
  }.svg`;
  event.target.onerror = null; // To prevent infinite loop if the default image is also not available
  event.target.src = placeholderImageUrl;
}

// format string. remove accents, replace spaces with dashes and lowercase
export function formatString(string) {
  return string
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]/g, "");
}

// image name format for candidates images
export function imageNameFormat(firstname, lastname) {
  if (firstname.indexOf(" ") > -1) {
    return (
      formatString(firstname.split(" ")[0]) +
      "_" +
      formatString(firstname.split(" ")[1]) +
      "_" +
      formatString(lastname)
    );
  }
  if (lastname.indexOf(" ") > -1) {
    return (
      formatString(firstname) +
      "_" +
      formatString(lastname.split(" ")[0]) +
      "_" +
      formatString(lastname.split(" ")[1])
    );
  }

  return (formatString(firstname) + "_" + formatString(lastname)).toLowerCase();
}

export function checkCompletion(id, arr) {
  return arr.every((obj) => obj.id.toString() !== id || obj.complete);
}

// export function onPartySearch(query) {
//   window.location.href = `?party=${query.partyId}`;
// }
